import './styles.scss';

import { keys } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import { DropdownSelect } from '../../../../components/DropdownSelect';
import Auth from '../../../../services/auth';
import { alertWarning } from '../../../../store/ducks/alert';

export class Launcher extends React.Component {
  state = {
    envs: [],
    tools: [],
    envTools: [],
    selectedEnv: null,
    selectedToolUrl: null,
    toolDropdownId: 0,
  };

  // eslint-disable-next-line react/sort-comp
  NO_ENV_WARNING = 'No authorized environments available';

  NO_TOOLS_WARNING = 'No authorized tool available in';

  componentDidMount() {
    const envTools = Auth.getEnvTools();
    const envs = keys(envTools);

    this.setState({ envTools, envs });

    if (envs.length === 0) {
      this.promptWarning(this.NO_ENV_WARNING);
    } else if (envs.length === 1) {
      this.setState({
        tools: keys(envTools[envs[0]]),
        selectedEnv: envs[0],
      });

      if (keys(envTools[envs[0]]).length === 0) {
        this.promptWarning(`${this.NO_TOOLS_WARNING} ${envs[0]}`);
      } else if (keys(envTools[envs[0]]).length === 1) {
        const obj = envTools[envs[0]];
        const selectedToolUrl = Object.values(obj)[0];

        this.setState({ selectedToolUrl }, this.handleLaunchBtnClick);
      }
    }
  }

  handleEnvSelect = (env) => {
    const { envTools, toolDropdownId } = this.state;

    this.setState({
      tools: keys(envTools[env]),
      selectedEnv: env.length === 0 ? null : env,
      selectedToolUrl: null,
      toolDropdownId: toolDropdownId + 1,
    });

    if (env.length > 0 && keys(envTools[env]).length === 0) {
      this.promptWarning(`${this.NO_TOOLS_WARNING} ${env}`);
    }
  };

  handleToolSelect = (tool) => {
    const { envTools, selectedEnv } = this.state;
    const toolList = envTools[selectedEnv];
    const selectedToolUrl = toolList[tool];

    this.setState({ selectedToolUrl });
  };

  handleLaunchBtnClick = () => {
    const { selectedToolUrl } = this.state;

    window.location.assign(`https://${selectedToolUrl}/#id_token=${Auth.getToken()}`);
  };

  promptWarning = (message) => {
    const { dispatch } = this.props;

    dispatch(alertWarning(message));
  };

  render() {
    const {
      envs,
      tools,
      selectedToolUrl,
      toolDropdownId,
    } = this.state;

    const currentEnvironment = Auth.getEnvText();

    return (
      <>
        <Row noGutters>
          <h1 className="mb-4">
            Select account and tool to launch
          </h1>
        </Row>
        <Row noGutters>
          <Col xs={5}>
            <DropdownSelect
              defaultText="Select Environment"
              values={envs}
              onSelect={this.handleEnvSelect}
              setActiveValue={envs.length === 1 ? envs[0] : undefined}
              disabled={currentEnvironment !== 'prd' && currentEnvironment !== 'ci'}
            />
          </Col>
          <Col xs={5}>
            <DropdownSelect
              key={toolDropdownId}
              defaultText="Select Tool"
              values={tools}
              onSelect={this.handleToolSelect}
              setActiveValue={tools.length === 1 ? tools[0] : undefined}
            />
          </Col>
          { selectedToolUrl && (
            <Col xs={2}>
              <Button
                className="Launcher__Button"
                onClick={this.handleLaunchBtnClick}
                disabled={selectedToolUrl === null}
              >
                LAUNCH
              </Button>
            </Col>
          )}
        </Row>
      </>
    );
  }
}

Launcher.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(Launcher);
